import React from 'react';
import { Droplets, Wind, Sun, ShieldCheck, Sparkles, AlertTriangle } from 'lucide-react';

const CareGuidePage = () => {
  return (
    <div className="pt-32 pb-20">
      <div className="max-w-4xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <h1 className="text-4xl font-light tracking-wider mb-4">BAKIM ÖNERİLERİ</h1>
          <p className="text-gray-500 max-w-2xl mx-auto">
            Has ipek fularlarınızın uzun ömürlü ve güzel kalması için bakım önerilerimizi takip edin.
          </p>
        </div>

        {/* İpek Hakkında */}
        <section className="mb-16">
          <div className="bg-amber-50 border border-amber-200 rounded-lg p-8">
            <h2 className="text-2xl font-light tracking-wider mb-4 flex items-center gap-2">
              <Sparkles className="text-amber-600" />
              Has İpeğin Özellikleri
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Has ipek, doğal bir protein lifidir ve cildinize birçok fayda sağlar:
            </p>
            <ul className="space-y-2 text-gray-700">
              <li className="flex items-start gap-2">
                <span className="text-amber-600 mt-1">•</span>
                <span><strong>Cilt Dostu:</strong> İpek, cildi nemlendirmeye yardımcı olur ve tahrişi önler.</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-amber-600 mt-1">•</span>
                <span><strong>Hipoalerjenik:</strong> Doğal yapısı sayesinde alerjik reaksiyonlara neden olmaz.</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-amber-600 mt-1">•</span>
                <span><strong>Saç Koruyucu:</strong> Saç kırılmasını ve elektriklenmesini önler.</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-amber-600 mt-1">•</span>
                <span><strong>Sıcaklık Düzenleyici:</strong> Yazın serin, kışın sıcak tutar.</span>
              </li>
            </ul>
          </div>
        </section>

        {/* Yıkama Talimatları */}
        <section className="mb-16">
          <h2 className="text-2xl font-light tracking-wider mb-8 flex items-center gap-2">
            <Droplets className="text-blue-500" />
            Yıkama Talimatları
          </h2>
          
          <div className="grid md:grid-cols-2 gap-6">
            <div className="bg-white border p-6 rounded-lg">
              <h3 className="font-medium mb-4 text-green-700">✓ Yapılması Gerekenler</h3>
              <ul className="space-y-3 text-sm text-gray-600">
                <li className="flex items-start gap-2">
                  <span className="text-green-500 mt-0.5">✓</span>
                  <span>Elle yıkayın veya makinede "hassas" programı kullanın</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-green-500 mt-0.5">✓</span>
                  <span>Ilık su (maksimum 30°C) kullanın</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-green-500 mt-0.5">✓</span>
                  <span>pH dengeli, ipek için özel deterjan tercih edin</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-green-500 mt-0.5">✓</span>
                  <span>Benzer renkleri birlikte yıkayın</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-green-500 mt-0.5">✓</span>
                  <span>Durulama suyuna 1 çay kaşığı sirke ekleyin (parlaklık için)</span>
                </li>
              </ul>
            </div>

            <div className="bg-white border p-6 rounded-lg">
              <h3 className="font-medium mb-4 text-red-700">✗ Kaçınılması Gerekenler</h3>
              <ul className="space-y-3 text-sm text-gray-600">
                <li className="flex items-start gap-2">
                  <span className="text-red-500 mt-0.5">✗</span>
                  <span>Çamaşır suyu veya ağartıcı kullanmayın</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-red-500 mt-0.5">✗</span>
                  <span>Sıcak su (50°C üzeri) kullanmayın</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-red-500 mt-0.5">✗</span>
                  <span>Kurutma makinesine koymayın</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-red-500 mt-0.5">✗</span>
                  <span>Sıkmayın veya burkmayın</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-red-500 mt-0.5">✗</span>
                  <span>Direkt güneş ışığında kurutmayın</span>
                </li>
              </ul>
            </div>
          </div>
        </section>

        {/* Kurutma */}
        <section className="mb-16">
          <h2 className="text-2xl font-light tracking-wider mb-8 flex items-center gap-2">
            <Wind className="text-cyan-500" />
            Kurutma Önerileri
          </h2>
          
          <div className="bg-gray-50 p-6 rounded-lg">
            <ol className="space-y-4 text-gray-700">
              <li className="flex items-start gap-3">
                <span className="w-6 h-6 bg-black text-white rounded-full flex items-center justify-center flex-shrink-0 text-sm">1</span>
                <span>Yıkadıktan sonra hafifçe sıkarak fazla suyu alın (burmayın).</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-6 h-6 bg-black text-white rounded-full flex items-center justify-center flex-shrink-0 text-sm">2</span>
                <span>Temiz bir havlunun üzerine yayın ve rulo yaparak kalan nemi alın.</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-6 h-6 bg-black text-white rounded-full flex items-center justify-center flex-shrink-0 text-sm">3</span>
                <span>Düz bir yüzeye yayarak veya plastik askıya asarak kurumaya bırakın.</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-6 h-6 bg-black text-white rounded-full flex items-center justify-center flex-shrink-0 text-sm">4</span>
                <span>Gölgede, havadar bir ortamda kurutun.</span>
              </li>
            </ol>
          </div>
        </section>

        {/* Ütüleme */}
        <section className="mb-16">
          <h2 className="text-2xl font-light tracking-wider mb-8 flex items-center gap-2">
            <Sun className="text-orange-500" />
            Ütüleme
          </h2>
          
          <div className="bg-white border p-6 rounded-lg">
            <ul className="space-y-3 text-gray-700">
              <li className="flex items-start gap-2">
                <span className="text-orange-500 mt-1">•</span>
                <span>Hafif nemli iken, ters yüzünden ütüleyin.</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-orange-500 mt-1">•</span>
                <span>Düşük sıcaklık ayarı (ipek ayarı) kullanın.</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-orange-500 mt-1">•</span>
                <span>Buhar kullanabilirsiniz, ancak direkt temas ettirmeyin.</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-orange-500 mt-1">•</span>
                <span>İpek üzerine ince bir bez koyarak ütülemek ekstra koruma sağlar.</span>
              </li>
            </ul>
          </div>
        </section>

        {/* Saklama */}
        <section className="mb-16">
          <h2 className="text-2xl font-light tracking-wider mb-8 flex items-center gap-2">
            <ShieldCheck className="text-purple-500" />
            Saklama Önerileri
          </h2>
          
          <div className="grid md:grid-cols-2 gap-6">
            <div className="bg-white border p-6 rounded-lg">
              <h3 className="font-medium mb-4">Kısa Süreli Saklama</h3>
              <ul className="space-y-2 text-sm text-gray-600">
                <li>• Askıya asarak veya katlanmış şekilde saklayın</li>
                <li>• Serin ve kuru bir ortamda tutun</li>
                <li>• Direkt güneş ışığından koruyun</li>
              </ul>
            </div>

            <div className="bg-white border p-6 rounded-lg">
              <h3 className="font-medium mb-4">Uzun Süreli Saklama</h3>
              <ul className="space-y-2 text-sm text-gray-600">
                <li>• Pamuklu bir kılıf veya toz çantası içinde saklayın</li>
                <li>• Plastik poşet kullanmaktan kaçının (nem birikir)</li>
                <li>• Lavanta veya sedir ağacı parçaları koyun (güve önlemi)</li>
                <li>• Periyodik olarak havalandırın</li>
              </ul>
            </div>
          </div>
        </section>

        {/* Leke Çıkarma */}
        <section className="mb-16">
          <h2 className="text-2xl font-light tracking-wider mb-8 flex items-center gap-2">
            <AlertTriangle className="text-yellow-500" />
            Leke Çıkarma İpuçları
          </h2>
          
          <div className="bg-yellow-50 border border-yellow-200 p-6 rounded-lg">
            <p className="text-gray-700 mb-4">
              <strong>Önemli:</strong> Lekeyi hemen müdahale edin. Ne kadar çabuk müdahale ederseniz, 
              leke o kadar kolay çıkar.
            </p>
            <ul className="space-y-3 text-gray-700">
              <li className="flex items-start gap-2">
                <span className="text-yellow-600 mt-1">⚠</span>
                <span><strong>Yağ lekeleri:</strong> Mısır unu veya talk pudrası serpin, 30 dakika bekletin, fırçalayın.</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-yellow-600 mt-1">⚠</span>
                <span><strong>Şarap/Kahve:</strong> Hemen soğuk su ile durulayın, ardından hafif sabunlu su ile yıkayın.</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-yellow-600 mt-1">⚠</span>
                <span><strong>Makyaj:</strong> İpek için özel leke çıkarıcı kullanın veya profesyonel temizliğe gönderin.</span>
              </li>
            </ul>
          </div>
        </section>

        {/* İletişim */}
        <section className="text-center">
          <div className="bg-gray-100 p-8 rounded-lg">
            <h3 className="text-xl font-light mb-4">Sorularınız mı var?</h3>
            <p className="text-gray-600 mb-4">
              Bakım konusunda herhangi bir sorunuz varsa bizimle iletişime geçmekten çekinmeyin.
            </p>
            <a 
              href="https://wa.me/905465937071" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-green-600 text-white px-6 py-3 rounded-lg hover:bg-green-700 transition-colors"
            >
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
              </svg>
              WhatsApp ile İletişim
            </a>
          </div>
        </section>
      </div>
    </div>
  );
};

export default CareGuidePage;
